<template>
  <div v-loading="courseAllLoading" class="course-all-box">
    <div style="margin-bottom:20px;display: flex;justify-content: space-between;padding-right:64px;">
      <div>
        门店：
        <el-select
          v-model="siteId"
          filterable
          remote
          reserve-keyword
          placeholder="请选择门店"
          :remote-method="getSiteList"
          :loading="selectloading"
          clearable
        >
          <el-option
            v-for="item in siteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-button-group>
        <el-button type="primary" icon="el-icon-arrow-left" @click="changeWeek(-1)">上一周</el-button>
        <el-button type="primary" @click="changeWeek(1)">下一周<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        <el-button v-if="week !== 0" type="primary" icon="el-icon-refresh-left" @click="changeWeek(0)">回到本周</el-button>
      </el-button-group>
    </div>
    <el-table :key="key" :data="tableData" border style="width:95%;height:684px;overflow-y: scroll;">
      <el-table-column v-for="(items,index) in dates" :key="index" :field="items.field" align="center" style="width:12.5%">
        <template v-if="index === 0" slot="header">
          <div class="header-div">
            <div class="header-col1">时间段</div>
            <div class="header-col2">日期</div>
            <div class="header-line"></div>
          </div>
        </template>
        <template v-else slot="header">
          <div>{{ items.week }}</div>
          <div>{{ items.date }}</div>
        </template>
        <template slot-scope="scope">
          <div v-if="items.field === 'time'" class="course-all-list">
            {{ scope.row[items.field] }}
          </div>
          <div v-else class="course-all-list">
            <!-- <el-button type="text" :disabled="scope.row[items.field].coach==0">教练：{{ scope.row[items.field].coach }}人</el-button> -->

            <el-popover placement="right" width="376" trigger="click" @show="coachShowData(scope.row.time,items.field)">
              <el-table v-if="coachShow == scope.row.time+'_'+items.field" v-loading="coachLoading" :data="coachData" height="383px">
                <el-table-column width="80" property="avatar" align="center" label="头像">
                  <template slot-scope="scope2">
                    <el-avatar :size="40" :src="scope2.row.avatar" @error="true">
                      <img :src="base_url+'static/image/default_avatar.png'">
                    </el-avatar>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="name" align="center" label="姓名"></el-table-column>
                <el-table-column width="120" property="phone" align="center" label="手机号"></el-table-column>
              </el-table>
              <el-button slot="reference" type="text" :disabled="scope.row[items.field].coach==0">教练：{{ scope.row[items.field].coach }}人</el-button>
            </el-popover>

            <el-popover placement="right" width="526" trigger="click" @show="bookShowData(scope.row.time,items.field,items.date)">
              <el-table v-if="bookShow == scope.row.time+'_'+items.field" v-loading="bookLoading" :data="bookData" height="383px">
                <el-table-column width="80" property="avatar" align="center" label="用户头像">
                  <template slot-scope="scope2">
                    <el-avatar :size="40" :src="base_url+scope2.row.avatar" @error="true">
                      <img :src="base_url+'static/image/default_avatar.png'">
                    </el-avatar>
                  </template>
                </el-table-column>
                <el-table-column width="100" property="nickname" align="center" label="用户昵称"></el-table-column>
                <el-table-column width="120" property="phone" align="center" label="用户手机号"></el-table-column>
                <el-table-column width="200" property="coach_name" align="center" label="教练名称"></el-table-column>
              </el-table>
              <el-button slot="reference" type="text" :disabled="scope.row[items.field].book==0">预约：{{ scope.row[items.field].book }}人</el-button>
            </el-popover>
            <!-- <el-button type="text" :disabled="scope.row[items.field].book==0">预约：{{ scope.row[items.field].book }}人</el-button> -->
          </div>
        </template>
      </el-table-column>

    </el-table>
  </div>

</template>

<script>
import api from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import site from '@/api/site/site'
export default {
  name: 'LessonCourseAll',
  // 列绑定格式化器
  filters: {
  },
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      api,
      dates: [],
      key: 0,
      week: 0,
      tableData: [],
      times: [],
      courseAllLoading: false,
      coachLoading: false,
      coachShow: '',
      coachData: [],
      bookLoading: false,
      bookShow: '',
      bookData: [],
      siteList: [],
      selectloading: false,
      siteId: ''
    }
  },
  watch: {
    siteId(val) {
      this.getDateAll()
      if (this.coachShow) {
        this.coachShowData(this.coachShow.split('_')[0], this.coachShow.split('_')[1])
      }
    }
  },
  beforeMount() {
    this.getdates()
    this.getSiteList('')
  },
  mounted() {
    this.getDateAll()
  },
  methods: {
    coachShowData(time, field) {
      this.coachData = []
      this.coachShow = time + '_' + field
      this.coachLoading = true
      api.CoachList({
        week: this.week,
        time: time,
        field: field,
        site_id: this.siteId
      }).then(res => {
        this.coachData = res.data
        this.coachLoading = false
      })
    },
    bookShowData(time, field, date) {
      this.bookShow = time + '_' + field
      this.bookLoading = true
      api.BookList({
        time: time,
        field: field,
        date: date
      }).then(res => {
        this.bookData = res.data
        this.bookLoading = false
      })
    },
    getSiteList(val) {
      this.selectloading = true
      site.Query({
        name: val, page: 1, limit: 10, sort: 'order_no', order: 'asc'
      }).then(res => {
        this.siteList = res.data.items
        this.selectloading = false
      })
    },
    getdates() {
      const now = new Date()
      const week = now.getDay()
      const weekLabels = ['一', '二', '三', '四', '五', '六', '日']
      const dates = [
        {
          field: 'time',
          week: '',
          date: ''
        }
      ]
      for (let i = 1; i <= 7; i++) {
        const date = new Date(now.getTime() - 24 * 60 * 60 * 1000 * (week - i - (this.week * 7)))
        dates.push({
          field: 'week' + i,
          week: '周' + weekLabels[i - 1],
          date: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        })
      }
      this.$nextTick(() => {
        this.dates = dates
        this.key = Math.random()
      })
    },
    getDateAll() {
      this.courseAllLoading = true
      api.DateAll({
        week: this.week,
        site_id: this.siteId
      }).then(res => {
        this.courseAllLoading = false
        this.tableData = res.data
      }).catch(() => { this.courseAllLoading = false })
    },
    changeWeek(num) {
      if (num === 0) {
        this.week = 0
      } else {
        this.week = this.week + num
      }
      this.getDateAll()
      this.getdates()
    }
  }
}
</script>
<style>
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}
.header-div {
	height: 50px;
	position: relative;
}
.header-col1 {
	position: absolute;
	left: 0;
	bottom: 0;
}
.header-col2 {
	position: absolute;
	right: 0;
	top: 0;
}
.header-line {
	padding-left: 0;
	width: 1px;
	height: 150px;
	transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
	-webkit-transform-origin: top;
	transform-origin: top;
	background-color: #fff;
  border-left:1px solid #e5e5e5;
}
.el-table::before{
  height:0 !important;
}

.course-all-box{
  width: 1260px;
  margin:20px auto;
  height:740px;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

</style>
